var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-app-modal", {
    attrs: { icon: ["fas", "map-marker-alt"], fluid: false },
    on: {
      "on-cancel-click": function ($event) {
        return _vm.$emit("on-cancel-click")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.i18n.t("modal:region_switcher.modal.title")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "text-center pb-2" }, [
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  { staticClass: "mb-4 font-weight-bolder text-secondary" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.i18n.t("modal:region_switcher.modal.description")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "text-left mb-3" },
                  _vm._l(_vm.state.benefits, function (benefit) {
                    return _c(
                      "li",
                      {
                        key: benefit,
                        staticClass: "mb-2 d-flex align-items-center",
                      },
                      [
                        _c("font-awesome-icon", {
                          directives: [
                            { name: "fancy-color", rawName: "v-fancy-color" },
                          ],
                          staticClass: "mr-3",
                          attrs: { icon: ["far", "plus"] },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "align-self-start" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(benefit) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center" },
                  [
                    _c("vue-smart-switch", {
                      model: {
                        value: _vm.state.hideForever,
                        callback: function ($$v) {
                          _vm.$set(_vm.state, "hideForever", $$v)
                        },
                        expression: "state.hideForever",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        attrs: { id: "region-switcher-modal-hide-label" },
                        on: {
                          click: function ($event) {
                            _vm.state.hideForever = !_vm.state.hideForever
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.i18n.t(
                                "modal:region_switcher.modal.hide-checkbox-label"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-light btn-sm mx-2 px-4",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("on-cancel-click")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.i18n.t("general:confirm.cancel_btn_text")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-brand mx-2 btn-sm px-4",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("on-accept-click", _vm.state.hideForever)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.i18n.t("general:confirm.confirm_btn_text")) +
                      "\n      "
                  ),
                ]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }